export type HostEnvironment = "development" | "staging" | "production";

export function isDevHost(hostname: string): boolean {
  if (hostname === "localhost" || hostname === "127.0.0.1" || hostname === "[::1]") return true;
  if (hostname.endsWith(".local") || hostname.endsWith(".localhost")) return true;
  return /^(10\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.)/.test(hostname);
}

export function hostEnvironment(hostname: string): HostEnvironment {
  if (isDevHost(hostname)) return "development";
  return hostname.includes("staging") ? "staging" : "production";
}

// The humanoid plan's footprints and warnings (D87): any host not known to be staging or local counts as production.
export const showsHumanoidDebug = (hostname: string): boolean => hostEnvironment(hostname) !== "production";
